import Integrations from 'pages/System/Integrations/Integrations';

export default function IntegrationsRoute() {
  return <Integrations />;
}
